export default function admin ({ next, store, nextMiddleware }) {
  if (!store.getters.isAdmin) {
    return next({ name: 'home' });
  }
  return nextMiddleware();
};
